<template>
  <div class="parents-section">
    <div class="header w1200 clearfix">
      <div class="header-left">
        <div class="hr"></div>
        <h2>家长说</h2>
        <h3>SINCE 1961</h3>
      </div>
    </div>
    <div class="content1_wrap">
      <div class="content1">
        <h3>麦芯儿妈妈</h3>
        <p>第一次家长开放日，我就参加了Kids 'R' Kids在中国的幼儿园的招生活动，那时孩子只有10个月，还不符合入园条件。好不容易等到孩子1岁7个月可以独立行走了，我们就赶紧把孩子送过来了。孩子特别喜欢这里的外教老师Kaseryn，每次回家都会和我模仿老师的一举一动。我们全家人都特别信任这里的老师。</p>
        <img src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/parents/parent_img1.jpg">
        <div v-show="this.$store.state.isMobile" class="content1-img-bg"></div>
        <div v-show="this.$store.state.isMobile" class="content1-img-shadow"></div>
      </div>
    </div>
    <div class="content2_wrap">
      <div class="content2">
        <h3>Olivia妈妈</h3>
        <p>孩子1岁多就送过来了。一开始家人很反对那么早送孩子过来，我也很焦虑，成天盯着手机监控看，动不动就给学校打电话。但是经过这三年，感觉这里的老师特别好，Olivia成长也很快。带她出去和朋友聚会，很明显能感受到她很自信，善于表达，英语口语也因为Kids 'R' Kids在中国的幼儿园浸入式的学习环境，感觉会发展得比同龄人好。</p>
        <img src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/parents/parent_img2.jpg">
      </div>
    </div>
    <div class="content3_wrap">
      <div class="content3">
        <h3>Isabella妈妈</h3>
        <p>我女儿是转学过来的。转学只有一年，我非常惊讶于Kids 'R' Kids在中国的幼儿园对我们的细心和用心。每天的Daily Report 让我及时了解孩子在幼儿园的情况，每学期也会有一对一的约谈。让我很震撼的是TSG的评估系统，足足有10大类38项的评估内容！每个学期末，老师会跟我们进行一对一的约谈，把孩子的情感发展、语言发育等等这些情况和我们沟通一下。现在，我的老二也刚刚送到KRK。</p>
        <img src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/parents/parent_img3.jpg">
        <div v-show="this.$store.state.isMobile" class="content3-img-bg"></div>
      </div>
    </div>
    <div class="content4_wrap">
      <div class="content4">
        <h3>Charles妈妈</h3>
        <p>我以前就是老师，希望给孩子找一个更符合他天性的幼儿园。后来接触到Kids 'R' Kids在中国的幼儿园，就觉得这里非常符合我的理念。孩子在这里呆了非常快乐的三年，我们也很惊讶于孩子的成长和变化。本来是很害羞的小男孩，现在越来越开朗，也敢于表达。在KG班学习到的多学科知识，也帮助孩子顺利地考上了心目中的理想学校——鼎石。很感谢这里的老师！</p>
        <img src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/parents/parent_img4.jpg">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {},
  components: {},
  methods: {}
};
</script>
<style rel="stylesheet/scss" lang="scss">
@import "@/assets/css/variables.scss";
.parents-section {
  width: 100%;
  margin: 0 auto;
  background: rgba(255, 255, 255, 1);
  .w1200 {
    width: 1200px !important;
    margin: 0 auto;
  }
  .header {
    width: 1200px;
    height: 155px;
    overflow: hidden;
    margin-top: 110px;
    margin-bottom: 50px;
    .header-left {
      float: left;
      .hr {
        width: 96px;
        height: 4px;
        background: rgba(174, 149, 79, 1);
      }
      h2 {
        width: 375px;
        height: 96px;
        font-size: 48px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        color: #333333;
        line-height: 96px;
      }
      h3 {
        width: 180px;
        height: 29px;
        line-height: 29px;
        background: rgba(174, 149, 79, 1);
        font-size: 24px;
        font-family: TimesNewRomanPS-BoldItalicMT;
        font-weight: bold;
        font-style: italic;
        color: rgba(255, 255, 255, 1);
        text-align: center;
      }
    }
  }
  .content_wrap {
    width: 100%;
    height: 444px;
    background: rgba(255, 255, 255, 1);
    margin: 0 auto;
    .content {
      width: 1200px;
      height: 444px;
      margin: 0 auto;
      p {
        width: 812px;
        height: 145px;
        font-size: 16px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 32px;
        margin-bottom: 0px;
      }
      p:nth-child(2) {
        margin: 52px 0px 102px 0px;
        width: 1075px;
        height: 80px;
      }
    }
  }
  .content1_wrap {
    width: 100%;
    height: 400px;
    background: rgba(12, 61, 126, 1);
    margin: 0 auto;
    .content1 {
      width: 1200px;
      height: 433px;
      margin: 0 auto;
      background: rgba(255, 255, 255, 1);
      position: relative;
      h3 {
        width: 100px;
        height: 20px;
        font-size: 20px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        line-height: 32px;
        position: absolute;
        top: 82px;
        left: 498px;
      }
      p {
        width: 533px;
        height: 144px;
        font-size: 16px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 32px;
        position: absolute;
        top: 155px;
        left: 65px;
      }
      img {
        width: 380px;
        height: 502px;
        position: absolute;
        top: 0px;
        right: 128px;
        z-index: 1;
      }
    }
  }
  .content2_wrap {
    width: 100%;
    height: 780px;
    background: url(https://krk-website.oss-cn-beijing.aliyuncs.com/img/parents/parent_yinying.jpg)
      no-repeat center -142px;
    margin: 0 auto;
    .content2 {
      width: 1200px;
      height: 780px;
      margin: 0 auto;
      position: relative;
      h3 {
        width: 95px;
        height: 19px;
        font-size: 20px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        line-height: 32px;
        position: absolute;
        top: 268px;
        right: 505px;
      }
      p {
        width: 498px;
        height: 145px;
        font-size: 16px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 32px;
        position: absolute;
        top: 341px;
        right: 101px;
      }
      img {
        width: 380px;
        height: 502px;
        position: absolute;
        top: 167px;
        left: 95px;
      }
    }
  }
  .content3_wrap {
    width: 100%;
    height: 408px;
    background: rgba(233, 234, 237, 1);
    margin: 0 auto;
    .content3 {
      width: 1200px;
      height: 408px;
      margin: 0 auto;
      background: rgba(255, 255, 255, 1);
      position: relative;
      h3 {
        width: 114px;
        height: 19px;
        font-size: 20px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        line-height: 32px;
        position: absolute;
        top: 89px;
        left: 486px;
      }
      p {
        width: 496px;
        height: 177px;
        font-size: 16px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 32px;
        position: absolute;
        top: 162px;
        left: 103px;
      }
      img {
        width: 380px;
        height: 502px;
        position: absolute;
        bottom: 0px;
        right: 128px;
      }
    }
  }
  .content4_wrap {
    width: 100%;
    height: 670px;
    background: rgba(255, 255, 255, 1);
    margin: 0 auto;
    .content4 {
      width: 1200px;
      height: 670px;
      margin: 0 auto;
      background: rgba(255, 255, 255, 1);
      position: relative;
      h3 {
        width: 114px;
        height: 19px;
        font-size: 20px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        line-height: 32px;
        position: absolute;
        top: 211px;
        right: 486px;
      }
      p {
        width: 496px;
        height: 176px;
        font-size: 16px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 32px;
        position: absolute;
        top: 284px;
        right: 103px;
      }
      img {
        width: 380px;
        height: 502px;
        position: absolute;
        top: 68px;
        left: 95px;
      }
      a {
        color: #094ca4;
        text-decoration: underline;
        position: absolute;
        bottom: 50px;
        left: 95px;
      }
    }
  }
}
@media (max-width: 767px) {
  .parents-section {
    .w1200 {
      width: 100% !important;
      margin: 0 auto;
    }
    .header {
      width: 100%;
      height: 64px;
      margin: 35px 0;
      .header-left {
        width: 100%;
        box-sizing: border-box;
        padding-left: 7.1%;
        .hr {
          width: 56px;
          height: 3px;
          background: rgba(174, 149, 79, 1);
        }
        h2 {
          width: 100%;
          height: 41px;
          font-size: 21px;
          font-weight: 500;
          color: #333333;
          line-height: 25px;
          font-family: PingFangSC-Medium;
          padding: 10px 0 8px;
          box-sizing: border-box;
        }
        h3 {
          width: 64px;
          height: 20px;
          font-size: 10px;
          font-family: TimesNewRomanPS-BoldItalicMT;
          font-weight: normal;
          line-height: 20px;
          background: rgba(174, 149, 79, 1);
          font-style: italic;
          color: rgba(255, 255, 255, 1);
          text-align: center;
          padding: 0 5px;
        }
      }
    }
    .content1_wrap {
      width: 100%;
      height: 205px;
      background: rgba(12, 61, 126, 1);
      margin-top: 79px;
      z-index: 99;
      .content1 {
        width: 100%;
        height: auto;
        margin: 0 auto;
        position: relative;
        .content1-img-bg {
          width: 83.3%;
          height: 250px;
          background: rgba(255, 255, 255, 1);
          position: absolute;
          top: 0;
          left: 8.3%;
          z-index: 99;
        }
        .content1-img-shadow {
          width: 83.3%;
          height: 100px;
          background: url(https://krk-website.oss-cn-beijing.aliyuncs.com/img/parents/parent_yinying.jpg)
      no-repeat center -156px;
          position: absolute;
          top: 176px;
          left: 8.3%;
        }
        h3 {
          width: 100%;
          height: 22px;
          font-size: 18px;
          line-height: 22px;
          position: absolute;
          text-align: center;
          top: 327px;
          left: 0%;
        }
        p {
          width: 100%;
          padding: 18px 8.2% 0;
          box-sizing: border-box;
          height: 144px;
          font-size: 13px;
          line-height: 21px;
          position: absolute;
          top: 365px;
          left: 0;
        }
        img {
          z-index: 100;
          width: 65.3%;
          height: auto;
          position: absolute;
          top: -27px;
          right: 17.3%;
        }
      }
    }
    .content2_wrap {
      width: 100%;
      height: 625px;
      background: none;
      margin: 0 auto;
      margin-top: 355px;
      .content2 {
        width: 100%;
        height: 625px;
        margin: 0 auto;
        position: relative;
        h3 {
          width: 100%;
          height: 22px;
          font-size: 18px;
          line-height: 22px;
          position: absolute;
          text-align: center;
          top: 370px;
          left: 0%;
        }
        p {
          width: 100%;
          padding: 18px 8.2% 0;
          box-sizing: border-box;
          height: 166px;
          font-size: 13px;
          line-height: 21px;
          position: absolute;
          top: 387px;
          left: 0;
        }
        img {
          width: 69.6%;
          height: auto;
          position: absolute;
          top: 0;
          left: 15.1%;
          z-index: 1;
        }
      }
    }
    .content3_wrap {
      width: 100%;
      height: 480px;
      margin: 0 auto;
      margin-top: 115px;
      z-index: 999;
      margin-bottom: 62px;
      .content3 {
        width: 100%;
        height: 480px;
        background: rgba(255, 255, 255, 1);
        position: relative;
        .content3-img-bg {
          width: 100%;
          height: 230px;
          background: #e9eaed;
        }
        h3 {
          width: 100%;
          height: 22px;
          font-size: 18px;
          line-height: 22px;
          position: absolute;
          text-align: center;
          top: 265px;
          left: 0%;
        }
        p {
          width: 100%;
          padding: 21px 8.2% 0;
          box-sizing: border-box;
          height: 190px;
          font-size: 13px;
          line-height: 21px;
          position: absolute;
          top: 287px;
          left: 0;
        }
        img {
          width: 69.5%;
          height: auto;
          position: absolute;
          top: -115px;
          right: 15.5%;
          z-index: 1;
        }
      }
    }
    .content4_wrap {
      width: 100%;
      height: 600px;
      background: none;
      margin: 0 auto;
      .content4 {
        width: 100%;
        height: 560px;
        margin: 0 auto;
        position: relative;
        h3 {
          width: 100%;
          height: 22px;
          font-size: 18px;
          line-height: 22px;
          position: absolute;
          text-align: center;
          top: 370px;
          left: 0%;
        }
        p {
          width: 100%;
          padding: 18px 8.2% 0;
          box-sizing: border-box;
          height: 166px;
          font-size: 13px;
          line-height: 21px;
          position: absolute;
          top: 387px;
          left: 0;
        }
        img {
          width: 69.2%;
          height: auto;
          position: absolute;
          top: 0;
          left: 15.1%;
          z-index: 1;
        }
      }
    }
  }
}
@media (min-width: 376px) and (max-width: 414px) {
  .parents-section {
    .content1_wrap {
      .content1 {
        h3 {
          top: 360px;
        }
        p {
          top: 380px;
        }
      }
    }
    .content2_wrap {
      .content2 {
        h3 {
          top: 405px;
        }
        p {
          top: 424px;
        }
      }
    }
    .content3_wrap {
      height: 490px;
      .content3 {
        height: 490px;
        .content3-img-bg {
          height: 263px;
        }
        h3 {
          top: 301px;
        }
        p {
          top: 323px;
          height: 171px;
        }
      }
    }
    .content4_wrap {
      height: 640px;
      .content4 {
        height: 600px;
        .content3-img-bg {
          height: 263px;
        }
        h3 {
          top: 408px;
        }
        p {
          top: 429px;
        }
      }
    }
  }
}
@media (min-width: 321px) and (max-width: 360px) {
  .parents-section {
    .content3_wrap {
      .content3 {
        .content3-img-bg {
          height: 215px;
        }
      }
    }
  }
}
@media (min-width: 320px) and (max-width: 320px) {
  .parents-section {
    .content1_wrap {
      height: 184px;

      .content1 {
        .content1-img-bg {
          height: 216px;
        }
        .content1-img-shadow {
          top: 144px;
        }
        h3 {
          top: 285px;
        }
        p {
          top: 308px;
          height: 165px;
        }
      }
    }
    .content2_wrap {
      height: 590px;
      .content2 {
        height: 590px;
        h3 {
          top: 320px;
        }
        p {
          top: 344px;
          height: 187px;
        }
      }
    }
    .content3_wrap {
      height: 455px;
      .content3 {
        height: 455px;
        .content3-img-bg {
          height: 179px;
        }
        h3 {
          top: 220px;
        }
        p {
          top: 244px;
          height: 210px;
        }
      }
    }
    .content4_wrap {
      .content4 {
        .content3-img-bg {
          height: 263px;
        }
        h3 {
          top: 334px;
        }
        p {
          top: 356px;
          height: 206px;
        }
      }
    }
  }
}

</style>


// WEBPACK FOOTER //
// src/pages/choose/parents.vue